import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
  import router from "@/router";
  import { MapPages } from "@/enums/MapPages";
  import { StageMapInterface } from "@/types/StageMapInterface";
  import { StageStatus } from "@/enums/StageStatus";
  import { useStore } from "vuex";
  import { compareStrings } from "@/helpers/transformation/string";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'StageNavMobile',
  props: {
    estateId: { type: String },
    viewType: { type: String },
    mapPage: { type: String },
    isEmbedded: { type: Boolean },
    isBuilderView: { type: Boolean, required: false },
    isMapModalView: { type: Boolean, required: false },
  },
  emits: ["changeView", "onStage"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;
  const stages = ref<StageMapInterface[]>([]);
  const store = useStore();
  const loading = ref(true);

  const getAvailableStages = computed(() => {
    return stages.value
      .filter((value) => value.stageId.status === StageStatus.NOW_SELLING)
      .sort((a, b) => compareStrings(a?.stageId?.title, b?.stageId?.title));
  });

  onMounted(() => {
    getStages();
  });

  const getStages = () => {
    store
      .dispatch("stage/getStagesMap", {
        estateId: props.estateId,
        isCustomer: true,
      })
      .then((res) => {
        stages.value = res.data;
        loading.value = false;
      });
  };

  const changeView = () => {
    if (props.viewType !== "list") {
      emit("changeView");
    }
  };

  const getStageClass = (stageId: string) => {
    return (
      router.currentRoute.value.query?.stageId === stageId &&
      props.mapPage === MapPages.STAGE_MAP
    );
  };

  const onStage = (stage: StageMapInterface) => {
    const embed = props.isEmbedded.toString();

    if (
      props.mapPage === MapPages.STAGE_MAP ||
      props.mapPage === MapPages.ESTATE_MAP
    ) {
      emit("onStage", stage);
    } else {
      router
        .replace({
          path: router.currentRoute.value.path,
          query: { stageId: stage.stageId._id, embed },
        })
        .then(() => {
          emit("changeView");
        });
    }
  };

const __returned__ = { props, emit, stages, store, loading, getAvailableStages, getStages, changeView, getStageClass, onStage, ref, computed, onMounted, get router() { return router }, get MapPages() { return MapPages }, get StageMapInterface() { return StageMapInterface }, get StageStatus() { return StageStatus }, get useStore() { return useStore }, get compareStrings() { return compareStrings } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})